import React from 'react';
import useAuth from '../../../utils/AuthContext';
import CustomerError from '../../../components/CustomerError';
import {UserType} from '../../../hooks/apis/useUser';
import KnowledgeBankEditForm, {IKnowledgeBankEditForm} from '../../../components/KnowledgeBank/EditForm';
import UseKnowledgeBank from '../../../hooks/apis/useKnowledgeBank';
import {Breadcrumb, Card, Divider, message, Space} from 'antd';
import QuickRouter from '../../../utils/QuickRouter';
import Title from 'antd/lib/typography/Title';
import KnowledgeBankQuestionManage from '../../../components/KnowledgeBank/QuestionManage';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import {useMount} from 'react-use';
import useQuickRouter from '../../../utils/QuickRouter';
import {useParams} from 'react-router-dom';

export default function ManageKnowledgeBankEditPage() {
  const auth = useAuth();
  const saveState = UseKnowledgeBank.save();
  const queryById = UseKnowledgeBank.queryById();
  const params = useParams() as {id?: string};
  const routeQueryId = params?.id || '';
  const quickRouter = useQuickRouter();

  function refresh() {
    queryById
      .request({
        id: parseInt(routeQueryId),
      })
      .then()
      .catch(CommonApiErrorHandler);
  }

  function save(form: IKnowledgeBankEditForm) {
    saveState
      .request(form)
      .then(() => {
        message.success('操作成功');
        refresh();
      })
      .catch(CommonApiErrorHandler);
  }

  useMount(() => {
    refresh();
  });

  if (!auth.currentUser || auth.currentUser.type !== UserType.管理员) return <CustomerError title={'无操作权限'} />;
  return (
    <div>
      <Breadcrumb className={'mb-md'}>
        <Breadcrumb.Item>
          <a onClick={quickRouter.index}>首页</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a onClick={quickRouter.manageKnowledgeBankList}>题库列表</a>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card title={'题库编辑: ' + queryById.data?.name}>
        <KnowledgeBankEditForm form={queryById.data ? {...queryById.data} : undefined} isLoading={saveState.loading} onFinish={save} />
        <Divider>题目列表</Divider>
        {queryById.data && <KnowledgeBankQuestionManage bank={queryById.data} />}
      </Card>
    </div>
  );
}
